export default __webpack_public_path__ + "static/media/IBMPlexSans-SemiBoldItalic-Latin1.174d1f4f.woff2";